import { createFileRoute } from '@tanstack/react-router';
import EmployeeCompletePage from '@/features/employee-onboarding/EmployeeCompletePage';

export const Route = createFileRoute('/e/employee-complete')({
  staticData: { hideShell: true },
  component: EmployeeCompletePage,
});
